import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * The one styling for a selected nav-ish item (active folder, work view,
 * sidebar row, segmented option): primary-tinted, matching the mail view
 * tabs. Inside a `.surface-dark` container (the plum rail, mobile dock) the
 * tokens remap, so the same class renders a light-orchid tint on dark. Use
 * this instead of hand-rolling bg-sidebar-accent / bg-accent variants so
 * active states stay consistent app-wide.
 */
export const navActiveClass =
  "bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary"
